import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';

export const aujourd_hui = [new Date(), new Date()];
export const hier = [addDays(new Date(), -1), addDays(new Date(), -1)];
export const semaine = [startOfWeek(new Date()), endOfWeek(new Date())];
export const mois = [startOfMonth(new Date()), new Date()];
